import moment from 'moment';

export const dateFormat = 'DD/MM/YYYY';
export const dateTimeFormat = 'DD/MM/YYYY HH:mm';
export const timeFormat = 'hh:mm';
export const time24hrFormat = 'HH:mm';
export const monthYearFormat = 'MM/YYYY';
export const emptyDateFormat = '--/--/--';
export const emptyTimeFormat = '--:--';
export const ISOStringFormat = 'YYYY-MM-DDT00:00:00';
export const dateFormatUS = 'MM/DD/YYYY';

export const formatarDataPadrao = (dat?: Date, validate?: boolean): string => {
  if (!dat) return '';
  
  const dateValue = new Date(dat);

  const dia = !isNaN(adicionaZero(dateValue.getDate().toString()))
    ? adicionaZero(dateValue.getDate().toString())
    : '00';
  const mes = !isNaN(adicionaZero(dateValue.getMonth() + 1).toString())
    ? adicionaZero(dateValue.getMonth() + 1).toString()
    : '00';
  const ano = !isNaN(dateValue.getFullYear()) ? dateValue.getFullYear() : '0000';

  const data = `${dia}/${mes}/${ano}`;

  if (validate && data == '00/00/0000') {
    return '';
  }

  return data;
};

function adicionaZero(numero: any) {
  if (numero <= 9) return '0' + numero;
  else return numero;
}

export const convertUTCtoLocal = (momentDate: moment.Moment) => {
  var date = new Date(
    Date.UTC(
      momentDate.year(),
      momentDate.month(),
      momentDate.date(),
      momentDate.hours(),
      momentDate.minutes(),
      momentDate.seconds(),
    ),
  );
  return date;
};


export const dataPorExtenso = () => new Date().toLocaleString([], { year: 'numeric', month: 'long', day: 'numeric' });

export function toStartOfDayISOString(date: Date): string {
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d.toISOString();
}

export function toEndOfDayISOString(date: Date): string {
  const d = new Date(date);
  d.setHours(23, 59, 59, 999);
  return d.toISOString();
}